<template>
<!-- 手机行业解决方案 -->
    <section class="solution household-solution">
        <div class="layout-banner">
            <div class="banner_box"></div>
            <div class="banner">
                <div class="banner-text w-1200">
                    <div class="big-text">家电行业解决方案</div>
                    <div class="sm-text">HOUSEHOLD APPLIANCE INDUSTRY SOLUTIONS</div>
                    <!-- <div class="line"></div> -->
                </div>
            </div>
            <Nav :activeIndex='"2-3"'></Nav>
        </div>
        <div class="solution-content">
            <p class="applications-title">家电行业解决方案</p>
            <p class="subhead">HOUSEHOLD APPLIANCE INDUSTRY SOLUTIONS</p>
            <div class="solution-context">
                <div class="w-1200">
                    <div class="title">行业痛点</div>
                    <div class="desc">
                        <el-row>
                            <el-col :span="6">家电产品厂保期限扩容，传统产品创新能力不足，无法吸引客户</el-col>
                            <el-col :span="6" :offset="3">购买通道狭窄，用户购买体验繁琐，产品往往无法有效转化真实需求客户</el-col>
                            <el-col :span="6" :offset="3">中小厂家、经销售延保产品销售能力建设受投产比问题制约</el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <div class="solution-scene">
                <div class="w-1200">
                    <div class="title">主流场景</div>
                    <div class="desc">
                        <ul class="clearfix">
                            <div class="tabs-bar" :style="`transform: translate3d(${tabsBarleft}px, 0px, 0px);`"></div>
                            <li :style="`left:${index*122}px`" v-for="(item, index) in allSceneList" :key="index" :class="[index===activeScene?'active':'']" @click="sceneClick(index)">{{item.name}}</li>
                        </ul>
                        <div class="scene-row">
                            <div class="scene-col">
                                <img src="../../assets/solution/jjfa_10.jpg" alt="">
                                <div class="scene-right">
                                    <h6>方案概要</h6>
                                    <div class="text">{{allSceneList[activeScene].outline}}</div>
                                </div>
                            </div>
                            <div class="scene-col">
                                <img src="../../assets/solution/jjfa_11.jpg" alt="">
                                <div class="scene-right">
                                    <h6>核心能力</h6>
                                    <div class="text">{{allSceneList[activeScene].ability}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <img :src="require(`../../assets/solution/icon${item}.png`)" alt="" v-for="item in 8" :key="item" :class="`icon${item}`">
            </div>
            <div class="solution-feature">
                <div class="w-1200">
                    <div class="title">能力模组</div>
                    <div class="desc">
                       <div class="left-top">
                            <div class="sub-title">智慧零售系统：</div>
                            <div>精准销售，即时分佣</div>
                        </div>
                        <div class="left-bottom">
                            <div class="sub-title">销售推动队伍：</div>
                            <div>专人专项提供销售支撑，覆盖激励方案、营销物料、巡店培训、知识库等</div>
                        </div>
                        <div class="right-top">
                            <div class="sub-title">供应链垂直管理：</div>
                            <div>服务交付环节“PC+小程序”，系统化管理，全流程覆盖</div>
                        </div>
                        <div class="right-bottom">
                            <div class="sub-title">售后网格服务：</div>
                            <div>家电维修90%以上县域覆盖，400+ 家电清洗等深度家电服务县域覆盖，200+ 家庭周边服务县域覆盖</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="solution-customer">
                <div class="w-1200">
                    <div class="title">合作客户</div>
                    <div class="desc">
                        <div class="customer"><img src="../../assets/partners/phone/partners2.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners4.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners5.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners6.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners13.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners14.jpg" alt=""></div>
                        <div class="itemempty"></div>
                        <div class="itemempty"></div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
        <Cornerbar></Cornerbar>
    </section>
</template>

<script>
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import Cornerbar from '@/components/Cornerbar'
export default {
  components: {
    Nav,
    Footer,
    Cornerbar
  },
  data () {
    return {
      tabsBarleft: 0,
      activeScene: 0,
      allSceneList: [{ name: '品牌厂商', outline: '向厂家提供包括产品定制、销售推动、保险安排在内完整的系统和业务解决方案', ability: '产品创新撬动真实客户需求，多层次、零等待的销售推动方案助力厂家激励线下渠道提升转化' },
        { name: '售后服务', outline: '结合售后服务渠道入户服务的特点提供一整套家电延保销售解决方案', ability: '全流程在线、数据闭环、即时返佣的移动端销售系统助力售服场景家电延保产品销售' },
        { name: '线下卖场', outline: '基于连锁卖场的新机销售场景及用户复购、多购的差异化需求，开展以换代修、保值换新、质保换新等服务创新类的产品合作', ability: '丰富的产品创新经验，以及基于底层数据和系统的创新产品定价能力、运营能力' }
      ]
    }
  },
  methods: {
    sceneClick (index) {
      this.activeScene = index
      this.tabsBarleft = index * 122
    }
  }
}

</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
.household-solution{
    .banner_box{
        background-image: url(../../assets/banner5.png);
    }
    .solution-content{
        .solution-context{
            margin: 40px 0 60px 0;
            .desc{
                width: 100%;
                margin-top: 30px;
                font-size: 14px;
                color: #666;
                line-height: 2;
                .el-col{
                    padding:40px 30px;
                    // height: 212px;
                    box-shadow:0px 2px 18px rgba(3, 123, 255, 0.1);
                    text-align: center;
                    cursor: pointer;
                    transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
                    img{
                        width: 60px;
                        height: 60px;
                    }
                    &:hover{
                        transform: translateY(-3px);
                        box-shadow: 0px 2px 18px rgba(3, 123, 255, 0.1);
                        transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
                    }
                }
            }
        }
        .solution-scene{
            .desc{
                ul{
                    width: 366px;
                }
            }
        }
        .solution-feature{
            background-color:#f5faff;
            padding-top: 40px;
            .desc{
                background-image: url(../../assets/solution/solution3.png);
                background-repeat: no-repeat;
                background-position: 50% 50%;
                height: 550px;
                width: 100%;
                position: relative;
                font-size: 14px;
                color: #666666;
                &>div{
                    position: absolute;
                    height: 71px;
                    width: 263px;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    .sub-title {
                        font-weight: 500;
                        // font-family: PingFangSC-Medium;
                        color: #333;
                    }
                }
                .left-top{
                    left: 52px;
                    top: 133px;
                }
                .left-bottom{
                    left: 52px;
                    top: 310px;
                }
                .right-top{
                    right: 52px;
                    top: 133px;
                }
                .right-bottom{
                    right: 52px;
                    top: 310px;
                }
            }
        }
    }
}
</style>
